import { createFileRoute } from '@tanstack/react-router';

import { HelpCenterPage, helpSearchSchema } from '@/features/tours';

/** Every operator may see it; it lists the tours their role can take. */
export const Route = createFileRoute('/_authed/help')({
  staticData: { crumbKey: 'nav.help', tours: ['platform.help'] },
  validateSearch: helpSearchSchema,
  component: HelpCenterPage,
});
